<div class="col-12 table-container">
    <table class="table table-striped table-bordered" id="gbd" aria-describedby="pending-items-table">
        <thead>
            <tr>
                <th *ngIf="showSerielNumber" scope="col">S. No</th>
                <th *ngFor="let column of columns" scope="col">{{column.name}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let d of data; let i = index" [routerLink]="routeTo?.replace('{0}', d.id)">
                <td *ngIf="showSerielNumber">{{i + 1}}</td>
                <td *ngFor="let column of columns" [ngClass]="column?.cssClasses ? column.cssClasses.join(' ') :''">
                    <ng-container *ngIf="column.type === columnType.HTML; else otherThanHTMLBlock">
                        <div *ngVar="(column.build(d)) as html" [innerHTML]="html"></div>
                    </ng-container>
                    <ng-template #otherThanHTMLBlock>
                        {{column.build(d)}}
                    </ng-template>
                </td>
            </tr>
            <tr *ngIf="!data || data.length === 0">
                <td class="no-rows-to-display" [attr.colspan]="columns.length + 1">No Rows To Display</td>
            </tr>
        </tbody>
    </table>
</div>